import { sv } from 'date-fns/locale';
import { ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { useUserDetailsQuery, useUserProfileFieldsQuery } from 'api';
import { ReactComponent as MaximizeIcon } from 'assets/icons/containerActions/maximize.svg';
import { GoBackButtonWithTitle, Spinner } from 'components';
import { useAuth, useSessionState, useWindowSize } from 'hooks';
import { Language } from 'types';
import { getFullName } from 'utils';

import { ExtendedDetailsInfoBlock, ProfileCard } from '../../components';
import { ExtendedDetailsAdapter } from '../EmployeeExtendedDetailsPage/adapter';
import { ContainerW, PageW } from './styled';
import { headerContainerSx, headerInnerSx, headerTitleSx } from './styles';

export function EmployeeSimplifiedDetails(): ReactElement {
  const { employeeId = '' } = useParams<string>();
  const { isMobile } = useWindowSize();
  const { isLoading, user } = useUserDetailsQuery({ employeeId });
  const { t } = useTranslation();
  const { isManager, user: currentUser } = useAuth();
  const [isExtendedView, setIsExtendedView] = useState(false);

  const [sessionState] = useSessionState('i18nextLng');
  const isSwedish = sessionState === Language.swedish;
  const locales = isSwedish ? sv : undefined;

  const isCurrentUser = currentUser?.id === user?.id;

  const { isLoading: isUserProfileOrderListLoading, userProfileFields = [] } =
    useUserProfileFieldsQuery({});

  if (!user) {
    return <></>;
  }

  const toggleExtendView = () => {
    setIsExtendedView(!isExtendedView);
  };

  const onHandleOpenChangeStatusModal = () => null;
  const { publicInfo } = ExtendedDetailsAdapter({
    user,
    isManager,
    isCurrentUser,
    locales,
    onHandleOpenChangeStatusModal,
    userProfileFields,
  });

  const fullName = getFullName({ firstName: user?.firstName, lastName: user?.lastName });

  if (isLoading || isUserProfileOrderListLoading) {
    return <Spinner />;
  }

  return (
    <PageW>
      {user && (
        <ContainerW>
          <GoBackButtonWithTitle
            title={fullName}
            containerSx={headerContainerSx(isMobile)}
            headerSx={headerInnerSx}
            titleSx={headerTitleSx}
            Actions={<MaximizeIcon style={{ opacity: '0.4' }} onClick={toggleExtendView} />}
          />

          {isExtendedView ? (
            <ExtendedDetailsInfoBlock
              title={t('profile.edit.form.publicInfo.title')}
              data={publicInfo}
            />
          ) : (
            <ProfileCard
              privateView={false}
              user={user}
              handleOpenModal={() => {}}
              userProfileFields={userProfileFields}
            />
          )}
        </ContainerW>
      )}
    </PageW>
  );
}
